import { render, staticRenderFns } from "./TournamentsComponent.vue?vue&type=template&id=10a7e9f8&"
import script from "./TournamentsComponent.vue?vue&type=script&lang=js&"
export * from "./TournamentsComponent.vue?vue&type=script&lang=js&"
import style0 from "./TournamentsComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports